import { useQuery } from '@tanstack/react-query';

import { getAttractionFilterOptions } from '~/services/AttractionsService';

import type { FilterOptionsParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

export function useGetAttractionFilterOptions(params: FilterOptionsParams) {
  return useQuery({
    queryKey: attractionQueryKeys.filterOptions(params.countryCode, params.state, params.province),
    queryFn: async ({ signal }) => {
      return await getAttractionFilterOptions(params, { signal });
    },
    enabled: !!params.countryCode,
    retry: false,
  });
}
